import useItemLocations from "../api/useItemLocations";

/**
 * Indicates whether the current item has no linked items across other boards
 * (i.e. ItemViewSection is rendering its empty state).
 *
 * Returns `false` while data is still loading so consumers default to the
 * "has items" UI rather than flashing the empty-state layout on first render.
 */
const useIsItemViewEmpty = (): boolean => {
  const { tableData } = useItemLocations();
  return tableData?.noLinkedItems === true;
};

export default useIsItemViewEmpty;
